import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('packstation-list', () => import(/* webpackMode: "lazy" */'./packstation-list'));
